import "es6-promise";
import Model from './Model';
import Backend from '../backend/Backend';

/**
 * A model that has a reference to a backend to store/get/delete the models
 */
class BackendModel extends Model {
	
	public backend:Backend;
	
	
	/**
	 * Saves the model through its backend
	 */
	public save():Promise<BackendModel> {
		
		var promise = ( this.get( 'id' ) ) ? this.backend.update( this ) : this.backend.create( this );
		
		return promise.then( function( model:BackendModel ) {
			this.sync( model.object() );
			return model;
		}.bind( this ));
	}
	
	/**
	 * Deletes the model through its backend
	 */
	public delete():Promise<BackendModel> {
		return this.backend.delete( this );
	}
}

export default BackendModel;